import Outpost from "./js/outpost.js";

const outpost = new Outpost(OutpostPub !== undefined ? OutpostPub : {})
outpost.init()

window.OutpostPubJs = outpost
